
let AGENTASSIST_API_SERVER_URL = '/agentassist';

let endPoints: any = generateEndPoints(AGENTASSIST_API_SERVER_URL);

function generateEndPoints(AGENTASSIST_API_SERVER_URL : string){
  return {
    'jwt_grant': '/api/1.1/oAuth/token/jwtgrant',
    'jwt_load' : AGENTASSIST_API_SERVER_URL + '/api/v1/aa/load',
    'get_aa_settings': AGENTASSIST_API_SERVER_URL +'/api/v1/agentassist/:botId/agentassistsetting?e=:channel',
    'get_history_trascript': AGENTASSIST_API_SERVER_URL + '/api/v1/agentassistconversations/:conversationId/conversation?page=0&limit=-1&botId=:botId&sessionId=:sessionId&isSummaryRequired=:isSummaryRequired&experience=:channel&pId=:pId&isRuntimeCall=true',
    'get_checklist': AGENTASSIST_API_SERVER_URL + '/api/v1/agentcoachingconfiguration/checklist/:botId/activeChecklists?cId=:cId&pId=:pId',
    'post_filetoken': '/api/1.1/attachment/file/token',
    'post_uploadfaqfile_chunk': '/api/1.1/attachment/file/:fileToken/chunk',
    'post_uploadfaqfile_fileId': '/api/1.1/attachment/file/:fileToken',
    'post_uploadfile': '/api/1.1/attachment/file',
    'get_uploadedfile': '/api/1.1/attachment/file/:fileId/url?isAgentAssist=true',
    'post_assist_history' : AGENTASSIST_API_SERVER_URL + '/api/v1/aaWidgetHistory?agentHistory=false&convId=:convId&limit=-1',
    'get_feedback' : AGENTASSIST_API_SERVER_URL + '/api/v1/agent-feedback/:conversationId?interaction=:tab',
    'post_mybot_history' : AGENTASSIST_API_SERVER_URL + '/api/v1/aaWidgetHistory?agentHistory=true&convId=:convId&limit=-1',
    'aa_prefs_settings' : AGENTASSIST_API_SERVER_URL + '/api/v1/aaprefs/:instanceBotId?channel=:channel&lang=:lang',
    'copilotMessages' : AGENTASSIST_API_SERVER_URL + '/api/v1/agentassistconversations/:convId/linkedapps/history?skip=:skip&limit=:limit&msgDirection=:msgDirection'
  };
}

const fetchInstance = async (endPoint: string, options: any = {}, hostInst: any, params?: any) => {
  try {
    const replacedURL = replaceValuesInString(endPoints[endPoint], params);
    const { domainURL, botId } = hostInst.rootService.connectionDetails;
    const { accountId } = hostInst.rootService.grantResponseObj?.userInfo || {};
    const { accessToken } = hostInst.rootService.grantResponseObj?.authorization || {};

    let headers = new Headers(options.headers || {});
    let headerObj: any = { iid: botId, accountId, Authorization: 'bearer ' + accessToken };

    if ((replacedURL.includes('/attachment/file') || replacedURL.includes('/file'))) {
      headerObj.iid = '',
        headerObj.accountId = ''
      if (options?.method == 'GET') {
        headerObj['Content-Type'] = 'application/json';
      }
    } else {
      headerObj['Content-Type'] = 'application/json';
    }

    Object.keys(headerObj).forEach((key) => {
      headers.set(key, headerObj[key]);
    });

    const modifiedOptions = {
      ...options,
      headers,
    };

    const API_URL = domainURL + replacedURL;
    const response = await fetch(API_URL, modifiedOptions);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Something went wrong');
    };
    return await response.json();
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

function replaceValuesInString(template: any, values: any) {
  return template.replace(/:(\w+)/g, (_: any, key: any) => {
    return values[key] !== undefined ? values[key] : `:${key}`;
  });
}

export function updateEndPointUrl(isNew : boolean){
  AGENTASSIST_API_SERVER_URL = (isNew ? '/agentai' : '/agentassist');
  endPoints = generateEndPoints(AGENTASSIST_API_SERVER_URL);
}
export default fetchInstance;
